import type { Avatar, Role } from "@coup/shared";

/** SVG paths on a 24×24 grid, stroked. */
export const ICONS = {
  crown: "M3 18h18M4 18 3 8l5 4 4-7 4 7 5-4-1 10",
  dagger: "M12 2v13M8 15h8M12 15v7M10 5l2-3 2 3",
  anchor: "M12 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM12 7v14M5 13a7 7 0 0 0 14 0M8 10h8",
  seal: "M3 6h18v12H3zM3 6l9 7 9-7",
  shield: "M12 3l8 3v6c0 5-4 8-8 9-4-1-8-4-8-9V6z",
  key: "M18 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM11 9 3 17v3h3v-2h2v-2h2l1-1",
  mask: "M3 7c3-1.5 6-1.5 9 0 3-1.5 6-1.5 9 0 0 6-3 10-9 10S3 13 3 7zM7 11h3M14 11h3",
  tower: "M6 21V8h12v13M6 8V4h2v2h2V4h4v2h2V4h2v4M10 21v-4h4v4",
  rose: "M12 21v-8M12 13c-4 0-6-3-6-6 3 0 5 1 6 3 1-2 3-3 6-3 0 3-2 6-6 6zM9 17c-2 0-3-1-3-2M15 17c2 0 3-1 3-2",
  quill: "M20 4C11 4 6 10 5 20M20 4c0 8-6 13-14 14M9 13h5",
  copy: "M9 9h11v11H9zM5 15H4V4h11v1",
  shuffle: "M16 3h5v5M4 20 21 3M21 16v5h-5M15 15l6 6M4 4l5 5",
  upload: "M12 16V4M7 9l5-5 5 5M4 16v4h16v-4",
  sound: "M4 9v6h4l5 4V5L8 9zM16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12",
  mute: "M4 9v6h4l5 4V5L8 9zM17 9l5 6M22 9l-5 6",
  collapseLeft: "M11 17l-5-5 5-5M18 17l-5-5 5-5",
  collapseRight: "M13 17l5-5-5-5M6 17l5-5-5-5",
  up: "M6 15l6-6 6 6",
  down: "M6 9l6 6 6-6",
  eye: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z",
} as const;

export interface RoleArt {
  name: string;
  color: string;
  icon: string;
  action: string;
  counter: string;
}

export const ROLE_ART: Record<Role, RoleArt> = {
  duke: {
    name: "Duke",
    color: "#6d43a0",
    icon: ICONS.crown,
    action: "Tax: take 3",
    counter: "Blocks Foreign Aid",
  },
  assassin: {
    name: "Assassin",
    color: "#3a3a42",
    icon: ICONS.dagger,
    action: "Pay 3: assassinate",
    counter: "No block",
  },
  captain: {
    name: "Captain",
    color: "#2d6cb4",
    icon: ICONS.anchor,
    action: "Steal 2 from a player",
    counter: "Blocks stealing",
  },
  ambassador: {
    name: "Ambassador",
    color: "#3d8f52",
    icon: ICONS.seal,
    action: "Exchange with the deck",
    counter: "Blocks stealing",
  },
  contessa: {
    name: "Contessa",
    color: "#b8403a",
    icon: ICONS.shield,
    action: "No action",
    counter: "Blocks assassination",
  },
};

export const COLOR_HEX: Record<Extract<Avatar, { kind: "preset" }>["color"], string> = {
  ochre: "#c9a24a",
  teal: "#3d7ea6",
  plum: "#a64d79",
  moss: "#6b8f3a",
  rust: "#c46a2c",
  slate: "#7d8aa0",
  rose: "#d08a8a",
  ivory: "#e6dcc4",
};

export const FRAME_HEX: Record<Avatar["frame"], string> = {
  gold: "#d4ad55",
  silver: "#b8bcc4",
  bronze: "#a8703a",
};

export const EMBLEM_PATH: Record<Extract<Avatar, { kind: "preset" }>["emblem"], string> = {
  crown: ICONS.crown,
  key: ICONS.key,
  mask: ICONS.mask,
  tower: ICONS.tower,
  rose: ICONS.rose,
  quill: ICONS.quill,
};

const capitalise = (s: string) => s[0]!.toUpperCase() + s.slice(1);
export const label = capitalise;
